import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3e8a254e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modern-form-container" }
const _hoisted_2 = { class: "form-progress mb-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "1", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Informations sur l'étudiant", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "2", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Pièces à fournir", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "card modern-card" }
const _hoisted_10 = { class: "card-body p-4" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "step-title mb-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle me-2" }),
  /*#__PURE__*/_createTextVNode(" Informations de l'étudiant ")
], -1))
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = { class: "modern-input-group" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "numeroMatricule",
  class: "modern-label"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book me-2" }),
  /*#__PURE__*/_createTextVNode(" Numéro Matricule ")
], -1))
const _hoisted_16 = { class: "col-md-4" }
const _hoisted_17 = { class: "modern-input-group" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "nom",
  class: "modern-label"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book me-2" }),
  /*#__PURE__*/_createTextVNode(" Nom"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = { class: "modern-input-group" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "prenom",
  class: "modern-label"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book me-2" }),
  /*#__PURE__*/_createTextVNode(" Prénom "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_22 = { class: "col-md-4" }
const _hoisted_23 = { class: "modern-input-group" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "modern-label"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book me-2" }),
  /*#__PURE__*/_createTextVNode(" Email "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_25 = { class: "col-md-4" }
const _hoisted_26 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Téléphone 1 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_28 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_29 = { class: "col-md-4" }
const _hoisted_30 = { class: "modern-input-group" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "anneeExperience",
  class: "modern-label"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book me-2" }),
  /*#__PURE__*/_createTextVNode(" Nombre d'années d'expériences ")
], -1))
const _hoisted_32 = { class: "col-md-4" }
const _hoisted_33 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Informations complémentaires "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = { class: "col-md-4" }
const _hoisted_37 = { class: "modern-input-group" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "dateNaissance",
  class: "modern-label"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar me-2" }),
  /*#__PURE__*/_createTextVNode(" Date de naissance"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_39 = { class: "col-md-4 mb-3" }
const _hoisted_40 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Sexe "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_42 = { class: "col-md-4" }
const _hoisted_43 = { class: "modern-select-group" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modern-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-folder me-2" }),
  /*#__PURE__*/_createTextVNode(" Niveau "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_45 = { class: "col-md-4" }
const _hoisted_46 = { class: "modern-select-group" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modern-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-folder me-2" }),
  /*#__PURE__*/_createTextVNode(" Filière "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_48 = { class: "col-md-4" }
const _hoisted_49 = { class: "modern-select-group" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modern-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-folder me-2" }),
  /*#__PURE__*/_createTextVNode(" Année académique "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_51 = { class: "col-md-4" }
const _hoisted_52 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Pays de résidence "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_54 = { class: "col-md-4" }
const _hoisted_55 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Commune "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_57 = { class: "col-md-4" }
const _hoisted_58 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Quartier "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_60 = { class: "col-md-4" }
const _hoisted_61 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Qualification "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_63 = { class: "col-md-4" }
const _hoisted_64 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Activité "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_66 = { class: "col-md-4" }
const _hoisted_67 = { class: "modern-select-group" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modern-label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createTextVNode("Parent "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      class: "btn btn-primary py-1 px-2 fs-12",
      style: {"cursor":"pointer"},
      "data-bs-toggle": "modal",
      "data-bs-target": "#AddElementModal",
      title: "Ajouter un nouveau parent"
    }, " Nouveau ")
  ])
], -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "step-title mb-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-tags me-2" }),
  /*#__PURE__*/_createTextVNode(" Pièces à fournir ")
], -1))
const _hoisted_70 = { class: "row" }
const _hoisted_71 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_72 = {
  class: "tab-pane fade show active p-10",
  id: "home-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_73 = { class: "row" }
const _hoisted_74 = { class: "border border-primary mb-1" }
const _hoisted_75 = {
  class: "row d-flex align-items-center justify-content-between fw-bold py-2",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-7" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fs-4 text-white" }, "Pièce(s)")
], -1))
const _hoisted_77 = { class: "col-md-5" }
const _hoisted_78 = { class: "d-flex float-end" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle position-relative ms-5 fs-12" }, null, -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row gx-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
      /*#__PURE__*/_createTextVNode("Type de pièce "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
      /*#__PURE__*/_createTextVNode("Numéro de pièce "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
      /*#__PURE__*/_createTextVNode("Image "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Action")
  ])
], -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-0" }, null, -1))
const _hoisted_82 = { class: "col-md-4 mb-3" }
const _hoisted_83 = { class: "modern-select-group" }
const _hoisted_84 = {
  key: 0,
  class: "col-md-4 mb-3"
}
const _hoisted_85 = { class: "modern-input-group" }
const _hoisted_86 = {
  key: 1,
  class: "col-md-4 mb-3"
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, "Aucun numéro requis pour la photo d'identité", -1))
const _hoisted_88 = [
  _hoisted_87
]
const _hoisted_89 = { class: "col-md-3 mb-3" }
const _hoisted_90 = { class: "form-group mb-0" }
const _hoisted_91 = {
  key: 2,
  class: "col-md-1 mb-3"
}
const _hoisted_92 = ["onClick"]
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-0 position-relative top-1" }, null, -1))
const _hoisted_94 = [
  _hoisted_93
]
const _hoisted_95 = { class: "form-navigation mt-4" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left me-2" }, null, -1))
const _hoisted_97 = {
  key: 1,
  type: "submit",
  class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
}
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-right ms-2" }, null, -1))
const _hoisted_99 = ["disabled"]
const _hoisted_100 = {
  key: 0,
  class: "fas fa-plus me-2"
}
const _hoisted_101 = {
  key: 1,
  class: "fas fa-spinner fa-spin me-2"
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times me-2" }, null, -1))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!
  const _component_AddParentModal = _resolveComponent("AddParentModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["step-container", `step-${_ctx.currentStep}`])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["step col-md-6", { active: _ctx.currentStep >= 1, completed: _ctx.currentStep > 1 }])
        }, _hoisted_5, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["step col-md-6", { active: _ctx.currentStep >= 2, completed: _ctx.currentStep > 2 }])
        }, _hoisted_8, 2)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_Form, {
          ref: "inscriptionForm",
          onSubmit: _ctx.nextStep,
          "validation-schema": _ctx.currentSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass([{ 'd-none': _ctx.currentStep !== 1 }, "step-content"])
            }, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createVNode(_component_Field, {
                      name: "numeroMatricule",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black modern-input",
                      placeholder: "Entrer le numéro"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "numeroMatricule",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_component_Field, {
                      name: "nom",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black modern-input",
                      placeholder: "Entrer le nom"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "nom",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createVNode(_component_Field, {
                      name: "prenom",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black modern-input",
                      placeholder: "Entrer le prénom"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "prenom",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_component_Field, {
                      name: "email",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black modern-input",
                      placeholder: "Entrer l'email"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "email",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createVNode(_component_Field, { name: "telephone1" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_vue_tel_input, _mergeProps({
                          placeholder: "Entrer le numéro de téléphone",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          defaultCountry: "BJ",
                          mode: "international",
                          onValidate: _ctx.validate,
                          class: "shadow-none fs-md-15 text-black py-2"
                        }), null, 16, ["modelValue", "onUpdate:modelValue", "onValidate"])
                      ]),
                      _: 1
                    }),
                    (!_ctx.validPhone)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, "Veuillez entrer un numéro correct"))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ErrorMessage, {
                      name: "telephone1",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createVNode(_component_Field, {
                      name: "anneeExperience",
                      type: "number",
                      class: "form-control shadow-none fs-md-15 text-black modern-input",
                      placeholder: "Entrer le nombre"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "anneeExperience",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createVNode(_component_Field, {
                      name: "biographie",
                      rows: "2",
                      as: "textarea",
                      placeholder: "Ajouter d'autres informations",
                      class: "form-control shadow-none rounded-0 text-black"
                    }, {
                      default: _withCtx(({ field }) => [
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                          class: "form-control shadow-none rounded-0 text-black"
                        }, null, 8, _hoisted_35), [
                          [_vModelText, field.value]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "biographie",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createVNode(_component_Field, {
                      name: "dateNaissance",
                      type: "date",
                      max: _ctx.currentDate,
                      class: "form-control shadow-none fs-md-15 text-black modern-input"
                    }, null, 8, ["max"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "dateNaissance",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createVNode(_component_Field, {
                      name: "sexe",
                      type: "text"
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          searchable: true,
                          options: [{ label: 'Masculin', value: 'Masculin' }, { label: 'Féminin', value: 'Féminin' }],
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner le sexe" }), null, 16, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "sexe",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _createVNode(_component_Field, {
                      name: "niveau",
                      type: "text"
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          options: _ctx.niveauOptions,
                          "preserve-search": true,
                          multiple: false,
                          searchable: true,
                          placeholder: "Sélectionner le niveau",
                          label: "label",
                          "track-by": "label"
                        }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "niveau",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createVNode(_component_Field, {
                      name: "filiere",
                      type: "text"
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          options: _ctx.filiereOptions,
                          "preserve-search": true,
                          multiple: false,
                          searchable: true,
                          placeholder: "Sélectionner la filière",
                          label: "label",
                          "track-by": "label"
                        }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "filiere",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _createVNode(_component_Field, {
                      name: "anneeId",
                      type: "text"
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          modelValue: _ctx.selectedAnnee,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAnnee) = $event))
                        }, field, {
                          options: _ctx.anneeOptions,
                          "preserve-search": true,
                          multiple: false,
                          searchable: true,
                          placeholder: "Sélectionner l'année académique",
                          label: "label",
                          "track-by": "value"
                        }), null, 16, ["modelValue", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "anneeId",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createVNode(_component_Field, {
                      name: "nationalite",
                      modelValue: _ctx.nationalite,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nationalite) = $event))
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.countries,
                          searchable: true,
                          "track-by": "value",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner le pays de résidence" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "nationalite",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _hoisted_56,
                    _createVNode(_component_Field, { name: "commune" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.communeOptions,
                          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.communeChange($event))),
                          searchable: true,
                          "track-by": "value",
                          label: "label",
                          modelValue: _ctx.selectedCommune,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedCommune) = $event))
                        }, field, { placeholder: "Sélectionner la commune" }), null, 16, ["options", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "commune",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _hoisted_59,
                    _createVNode(_component_Field, { name: "quartier" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.quartierOptions,
                          searchable: true,
                          "track-by": "value",
                          label: "label",
                          modelValue: _ctx.selectedQuartier,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedQuartier) = $event))
                        }, field, {
                          noOptionsText: "Sélectionner d'abord une commune",
                          placeholder: "Sélectionner le quartier"
                        }), null, 16, ["options", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "quartier",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _hoisted_62,
                    _createVNode(_component_Field, { name: "qualificationId" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.qualificationOptions,
                          searchable: true,
                          "track-by": "label",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner la qualification" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "qualificationId",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _hoisted_65,
                    _createVNode(_component_Field, { name: "activites" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.activiteOptions,
                          searchable: true,
                          mode: "tags",
                          "track-by": "label",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner l'activité" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "activites",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _hoisted_68,
                    _createVNode(_component_Field, { name: "parent" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          options: _ctx.parentsOptions,
                          "preserve-search": true,
                          multiple: false,
                          searchable: true,
                          placeholder: "Sélectionner le parent",
                          label: "label",
                          "track-by": "label"
                        }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "parent",
                      class: "text-danger"
                    })
                  ])
                ])
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass([{ 'd-none': _ctx.currentStep !== 2 }, "step-content"])
            }, [
              _hoisted_69,
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("div", _hoisted_75, [
                          _hoisted_76,
                          _createElementVNode("div", _hoisted_77, [
                            _createElementVNode("div", _hoisted_78, [
                              _createElementVNode("button", {
                                class: _normalizeClass(["default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success", { 'cursor-not-allowed': _ctx.isDisable }]),
                                type: "button",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addRowPiece()))
                              }, [
                                _hoisted_79,
                                _createTextVNode(" Ajouter une pièce ")
                              ], 2)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_80,
                          _hoisted_81,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pieces, (piece, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "row gx-1",
                              key: index
                            }, [
                              _createElementVNode("div", _hoisted_82, [
                                _createElementVNode("div", _hoisted_83, [
                                  _createVNode(_component_Field, {
                                    name: `pieces[${index}].typePiece`
                                  }, {
                                    default: _withCtx(({ field }) => [
                                      _createVNode(_component_Multiselect, _mergeProps({
                                        modelValue: _ctx.pieces[index].typePiece,
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.pieces[index].typePiece) = $event),
                                        ref_for: true
                                      }, field, {
                                        options: _ctx.typeOptions,
                                        "preserve-search": true,
                                        multiple: false,
                                        searchable: true,
                                        placeholder: "Sélectionner le type de pièce",
                                        label: "label",
                                        "track-by": "value",
                                        class: "modern-multiselect"
                                      }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                                    ]),
                                    _: 2
                                  }, 1032, ["name"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: `pieces[${index}].typePiece`,
                                    class: "text-danger"
                                  }, null, 8, ["name"])
                                ])
                              ]),
                              (!_ctx.isPhotoPiece(_ctx.pieces[index].typePiece))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                    _createElementVNode("div", _hoisted_85, [
                                      _createVNode(_component_Field, {
                                        type: "text",
                                        class: "form-control shadow-none fs-md-15 text-black modern-input",
                                        placeholder: "Entrer le numéro de la pièce",
                                        name: `pieces[${index}].numeroPiece`,
                                        modelValue: _ctx.pieces[index].numeroPiece,
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.pieces[index].numeroPiece) = $event)
                                      }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                                      _createVNode(_component_ErrorMessage, {
                                        name: `pieces[${index}].numeroPiece`,
                                        class: "text-danger"
                                      }, null, 8, ["name"])
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_86, _hoisted_88)),
                              _createElementVNode("div", _hoisted_89, [
                                _createElementVNode("div", _hoisted_90, [
                                  _createVNode(_component_Field, {
                                    type: "file",
                                    accept: "image/*,application/pdf,application/msword,video/mp4",
                                    class: "form-control",
                                    onChange: ($event: any) => (_ctx.handleFileChange($event, index)),
                                    name: `pieces[${index}].urlImage`
                                  }, null, 8, ["onChange", "name"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: `pieces[${index}].urlImage`,
                                    class: "text-danger"
                                  }, null, 8, ["name"])
                                ])
                              ]),
                              (index > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                    _createElementVNode("button", {
                                      class: "btn btn-danger transition border-0 py-1 px-2",
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.removeRowPiece(index))
                                    }, _hoisted_94, 8, _hoisted_92)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ], 2),
            _createElementVNode("div", _hoisted_95, [
              (_ctx.currentStep > 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-outline-secondary me-3",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
                  }, [
                    _hoisted_96,
                    _createTextVNode(" Précédent ")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.currentStep < 2)
                ? (_openBlock(), _createElementBlock("button", _hoisted_97, [
                    _createTextVNode(" Suivant "),
                    _hoisted_98
                  ]))
                : _createCommentVNode("", true),
              (_ctx.currentStep === 2)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "btn btn-success me-3",
                    type: "submit",
                    disabled: _ctx.isSubmitting
                  }, [
                    (!_ctx.isSubmitting)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_100))
                      : _createCommentVNode("", true),
                    (_ctx.isSubmitting)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_101))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.isSubmitting ? 'Enregistrement en cours...' : 'Enregistrer'), 1)
                  ], 8, _hoisted_99))
                : _createCommentVNode("", true),
              _createVNode(_component_router_link, {
                to: "/liste-demande-inscriptions",
                class: "btn btn-danger border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16"
              }, {
                default: _withCtx(() => [
                  _hoisted_102,
                  _createTextVNode(" Annuler ")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ]),
    _hoisted_103,
    _hoisted_104,
    _createVNode(_component_AddParentModal, {
      onClose: _ctx.handleClose,
      onRefresh: _ctx.loadParents
    }, null, 8, ["onClose", "onRefresh"])
  ]))
}